// @flow
import React, { type Node } from 'react';
import './EstimateBoxSection.scss';

type Props = {
  children: Node,
  name: string,
};

const EstimateBoxSection = ({ children, name }: Props) => (
  <section className="EstimateBoxSection">
    <h4>{name}</h4>
    <div className="section-contents">{children}</div>
  </section>
);

export default EstimateBoxSection;



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateBoxSection/EstimateBoxSection.js